import { inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { FILTER_PATTERNS } from '@shared/constants';
import { map, tap } from 'rxjs';

@Injectable()
export class RegisterGuardianshipFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  public readonly form = this._fb.group({
    userId: this._fb.control(0),

    email: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.email)],
    }),
    isFirm: this._fb.control(false),

    firstName: this._fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    middleName: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.name)],
    }),
    lastName: this._fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    phoneNumber: this._fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.phoneNumberFormatted)],
    }),
    username: this._fb.control('', {
      validators: [Validators.required, Validators.minLength(2)],
    }),
    prefixPhone: this._fb.control<string>(DEFAULT_USA_PHONE_PREFIX),
    courtOrder: this._fb.control<File | null>(null, {
      validators: [Validators.required],
    }),
  });

  private readonly _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  public setIsLoading(isLoading: boolean): void {
    this._isLoading.set(isLoading);
  }

  public readonly isFirm = toSignal(
    this.form.controls.isFirm.valueChanges.pipe(map((isFirm) => !!isFirm)),
    {
      initialValue: false,
    },
  );

  constructor() {
    this.form.controls.isFirm.valueChanges
      .pipe(
        tap((isFirm: boolean) => {
          if (isFirm) {
            this.form.controls.lastName.disable();
            this.form.controls.middleName.disable();

            this.form.controls.lastName.setValue('');
            this.form.controls.middleName.setValue('');
          } else {
            this.form.controls.lastName.enable();
            this.form.controls.middleName.enable();
            this.form.controls.prefixPhone.enable();
          }
          this.form.updateValueAndValidity();
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }
}
